import React from 'react';

import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import ReduxForm from '../../../components/UI/Form/ReduxForm'
import { formActions } from '../../../components/UI/Form/store/forms-reducer';

const FORMLABEL = 'basic';
// also change in useeffect below!

export const theForm = {
  pat_first_name: {
    tag: 'input',
    label: 'Vorname Patient oder Patientin ',
    attributes: {
      type: 'text',
      placeholder: 'Vorname',
      style: {width: '300px'}
    },
    validation: {
      required: true,
    },
    errorMessage: 'Bitte Vornamen eingeben'
  },
  pat_name: {
    tag: 'input',
    label: 'Name Patient oder Patientin',
    attributes: {
      type: 'text',
      placeholder: 'Name',
      style: {width: '300px'}
    },        
    validation: {
      required: true,
    },
    errorMessage: 'Bitte Namen eingeben'
  },
  XsmallskipA: {},
  XtextAA: {value: 'Abgesehen von Studien und Forschungsprojekten möchte ich kontaktiert werden:'},
  XlineBreakAA: {},
  accept_therapy: {
    tag: 'boxes',
    label: '',
    classname: 'NeinJa',
    containerclasses: 'TwoCols',
    attributes: {
      type: 'switch',
      options: [{value: 'false', label: 'für aktuelle Behandlungsmöglichkeiten'}],
    },
    value: 'true'
  },
  // accept_studies: {
  //   tag: 'boxes',
  //   label: '',
  //   classname: 'JaNein',
  //   containerclasses: 'TwoCols',
  //   attributes: {
  //     type: 'checkbox',
  //     options: [{value: 'true', label: 'für klinische Studien'}]
  //   },
  //   value: 'true'
  // },
  accept_reevaluation: {
    tag: 'boxes',
    label: '',
    classname: 'NeinJa',
    containerclasses: 'TwoCols',
    attributes: {
      type: 'switch',
      options: [{value: 'false', label: 'bei neuen wissenschaftlichen Erkentnissen'}]
    },    
    value: 'true'
  },
  XlineBreakB: {},
  accept_registers: {
    tag: 'boxes',
    label: '',
    classname: 'NeinJa',
    containerclasses: 'TwoCols',
    attributes: {
      type: 'switch',
      options: [{value: 'false', label: 'von Patientenregistern'}]
    },    
    value: 'true'
  },
  accept_organizations: {
    tag: 'boxes',
    label: '',
    classname: 'NeinJa',
    containerclasses: 'TwoCols',
    attributes: {
      type: 'switch',
      options: [{value: 'false', label: 'von Patientenorganisationen'}]
    },    
    value: 'true'
  },
  XlineBreakD: {},
  accept_patients: {
    tag: 'boxes',
    label: '',
    classname: 'NeinJa',
    containerclasses: 'TwoCols',
    attributes: {
      type: 'switch',
      options: [{value: 'false', label: 'von anderen registrierten Patienten'}]
    },    
    value: 'true'
  },
  XsmallskipZ: {},
  ref: {
    tag: 'input',
    label: 'Titel',
    attributes: {
      type: 'text',
      placeholder: 'Hier können Sie dem Befund einen Namen geben',
      style: {width: '400px'}
    }
  }
}

const requiredFields = Object.entries(theForm)
  .filter(([_, config]) => config.validation?.required)
  .map(([key]) => key);

const DataForm = ({ onValidChange, ...props }) => {
  const store = useSelector( state => state );
  const dispatch = useDispatch();
  const userIsPatient = store.forms.forms?.consent?.state.pat_relation.value === '0';
  const formState = useSelector(state => state.forms.forms[FORMLABEL]);

  const setFormValue = (form, field, value) => {
    dispatch( formActions.changeFormValue({
      label: form, 
      field: field, 
      state: {
        value: value,
        valid: true,
        touched: true,
        message: ""
      }
    }));
  };

  useEffect(() => {
    const valid = formState
      ? requiredFields.every(key => formState.state[key]?.valid)  
      : false;
    onValidChange(valid);
  }, [formState]);
  
  useEffect( () => {
    if (userIsPatient && store.forms.forms?.basic?.state?.pat_first_name?.value === "") {
      setFormValue( FORMLABEL, 'pat_first_name', store.forms.forms?.consent?.state.sig_first_name.value );
      setFormValue( FORMLABEL, 'pat_name', store.forms.forms?.consent?.state.sig_name.value );
    }
  }, [userIsPatient]);

  return <>
    <h1>Patienten Informationen</h1>
    <ReduxForm  
      entries = {theForm}
      label = {FORMLABEL}
    />
  </>
};

export default DataForm;